<div class="interiew-agent-user-media-wrapper">
    <div
      class="interview-agent-v2-user-media-section-bg"
      [ngClass]="{ animating: userSpeakingState }"
    >
      <div
        class="interview-agent-v2-user-media-section"
        [ngClass]="{ animating: userSpeakingState }"
      >
        <!-- Audio Waves -->
        <div class="audio-variations">
          <div
            *ngFor="let wave of [1, 2, 3]"
            class="sound-wave"
            [ngClass]="{ animating: userSpeakingState }"
          ></div>
        </div>
  
        <!-- Camera on -->
        <div *ngIf="isCameraOn" class="video-wrapper">
          <video
            #userVideoRef
            autoplay
            muted
            playsinline
          ></video>
        </div>
  
        <!-- Camera off -->
        <div
          *ngIf="!isCameraOn"
          class="wave-variations-bg"
          [ngClass]="{ outerWaveAnimating: userSpeakingState }"
        >
          <div
            class="user-name-avatar-wrapper"
            [ngClass]="{ small: isSmallBox }"
          >
            {{ firstLetter }}
          </div>
        </div>
      </div>
    </div>
  </div>
  